import React, {useState} from "react"
import {Button} from "@material-ui/core"
import {Add} from "@material-ui/icons"
import styled from "styled-components"

import {ExtendInstalmentCapModal} from "./ExtendInstalmentCapModal"

type ExtendInstalmentCapButtonProps = {
	customerID: string
	maximumExtendableDuration: number
	defaultMaxPaymentsWeekly: number
	currentMaxPaymentsWeekly: number
	totalCustomerBalance: number
	onSuccess: () => void
}

const ExtendInstalmentCapButton = ({
	customerID,
	maximumExtendableDuration,
	defaultMaxPaymentsWeekly,
	currentMaxPaymentsWeekly,
	totalCustomerBalance,
	onSuccess,
}: ExtendInstalmentCapButtonProps) => {
	const [extendModalOpen, setExtendModalOpen] = useState(false)

	const handleExtendClick = () => {
		setExtendModalOpen(true)
	}

	const handleModalClose = () => {
		setExtendModalOpen(false)
	}

	const handleSuccess = () => {
		setExtendModalOpen(false)
		onSuccess()
	}

	const isDisabled = defaultMaxPaymentsWeekly === maximumExtendableDuration || maximumExtendableDuration === 0

	return (
		<>
			<ExtendButton
				variant="outlined"
				color="primary"
				startIcon={<Add />}
				onClick={handleExtendClick}
				size="small"
				disabled={isDisabled}
			>
				EXTEND INSTALMENT CAPS
			</ExtendButton>
			{extendModalOpen && (
				<ExtendInstalmentCapModal
					onClose={handleModalClose}
					customerID={customerID}
					currentMaxPayments={maximumExtendableDuration}
					currentMinPayment={defaultMaxPaymentsWeekly}
					totalCustomerBalance={totalCustomerBalance}
					initialValue={currentMaxPaymentsWeekly}
					onSuccess={handleSuccess}
				/>
			)}
		</>
	)
}

const ExtendButton = styled(Button)`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 0.875rem;
	letter-spacing: 0.4px;
	border-color: #474cde;
	color: #474cde;
	border-radius: 0.25rem;
	border: 1px solid #474cde;

	&:hover {
		border-color: #474cde;
		background-color: rgba(71, 76, 222, 0.04);
	}
`

export {ExtendInstalmentCapButton}
